const how_often = [
    "Once", "Twice", "Thrice", "Four times", "Five times", "Six times", "Seven times", "Eight times", "Nine times", "Ten times", "Every 12 hours", "Every 8 hours", "Every 6 hours", "Every 4 hours", "Every 3 hours", "Every 2 hours", "Every hour", "Every 30 minutes", "Every 15 minutes", "As needed"
];

export default how_often;